import React, { Component } from 'react';
import { toast } from 'react-toastify';
import { Link } from 'react-router-dom';
import { deleteProduct, getProducts } from '../services/productService';
import auth from '../services/authService';
import _ from 'lodash';
import ProductBlock from './productBlock';
import Pagination from './Common/pagination';
import ProductsPageHero from './productsPageHero';
import FilterLayoutSort from './filterLayoutSort';
import DeletePopUp from './deletePopup';
import Loader from './loader';

class Products extends Component {
  state = {
    loading: true,
    categories: ['Cold drink', 'Juice', 'Water'],
    pageSize: 12,
    currentPage: 1,
    selectedCategory: 'All',
    searchQuery: '',
    deletePopup: false,
    deleteRequestedProduct: {},
    products: [],
    biggerLayout: true,
    sortBy: { path: 'label', order: 'asc' },
  };

  async componentDidMount() {
    window.scrollTo(0, 0);
    const categories = ['All', ...this.state.categories];
    let { category } = this.props.match.params;
    if (category) this.setState({ selectedCategory: category });

    const { data: pro } = await getProducts();
    this.setState({ products: pro, categories, loading: false });

    const user = auth.getCurrentUser();
    this.setState({ user });
  }

  changeLayout = () => {
    let { biggerLayout } = this.state;
    biggerLayout = !biggerLayout;
    this.setState({ biggerLayout });
  };

  handleDelete = async (product) => {
    const originalProducts = this.state.products;
    const products = originalProducts.filter((p) => p._id !== product._id);
    this.setState({ products });

    try {
      await deleteProduct(product._id);
      // await this.props.updateOnApp();
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast.error('Product already deleted.');
      this.setState({ products: originalProducts });
    }

    this.setState({ deleteRequestedProduct: {}, deletePopup: false });
  };

  handleDeletePopUP = (product) => {
    this.setState({ deleteRequestedProduct: product });

    let { deletePopup } = this.state;
    deletePopup = !deletePopup;
    this.setState({ deletePopup });
  };

  handleCategorySelect = (category) => {
    this.setState({
      selectedCategory: category,
      searchQuery: '',
      currentPage: 1,
    });
  };

  handleSort = (e) => {
    const currentValue = e.target.value;
    const splited = currentValue.split(' ');
    const sortBy = { path: splited[0], order: splited[1] };
    this.setState({ sortBy });
  };

  handleSearch = (query) => {
    this.setState({
      searchQuery: query,
      selectedCategory: 'All',
      currentPage: 1,
    });
  };

  handlePageChange = (page) => {
    window.scrollTo(0, 0);
    this.setState({ currentPage: page });
  };

  paginate = (items, pageNumber, pageSize) => {
    const startIndex = (pageNumber - 1) * pageSize;
    return _(items).slice(startIndex).take(pageSize).value();
  };

  getSortedData = () => {
    const {
      products,
      searchQuery,
      selectedCategory,
      sortBy,
      pageSize,
      currentPage,
    } = this.state;

    let filtered = products;
    if (searchQuery)
      filtered = products.filter((p) =>
        p.label.toLowerCase().includes(searchQuery.toLowerCase())
      );
    else if (selectedCategory !== 'All')
      filtered = products.filter((p) => p.category === selectedCategory);

    let sortedProducts = null;
    if (sortBy.path === 'price') {
      if (sortBy.order === 'asc') {
        sortedProducts = filtered.sort((a, b) => a.price - b.price);
      } else if (sortBy.order === 'desc') {
        sortedProducts = filtered.sort((a, b) => b.price - a.price);
      }
    } else {
      sortedProducts = _.orderBy(filtered, [sortBy.path], [sortBy.order]);
    }

    const finalProducts = this.paginate(sortedProducts, currentPage, pageSize);

    return { totalCount: sortedProducts.length, finalProducts };
  };

  render() {
    const {
      user,
      loading,
      biggerLayout,
      currentPage,
      pageSize,
      selectedCategory,
      searchQuery,
      deleteRequestedProduct,
      deletePopup,
    } = this.state;
    const { totalCount, finalProducts: products } = this.getSortedData();

    let delay = 0;
    const smallLayout = 'col-6 col-lg-2 col-md-4 col-sm-6';
    const bigLayout = 'col-12 col-lg-3 col-md-4 col-sm-12';

    return (
      <React.Fragment>
        <ProductsPageHero selectedCategory={selectedCategory} />
        {loading ? (
          <Loader />
        ) : (
          <>
            {user && user.isAdmin && (
              <div className='add-product-button'>
                <h1>Want to add new product?</h1>
                <Link to='/add-new-product/'>
                  <button>Add new Product</button>
                </Link>
              </div>
            )}

            <FilterLayoutSort
              selectedCategory={selectedCategory}
              handleCategorySelect={this.handleCategorySelect}
              searchQuery={searchQuery}
              handleSearch={this.handleSearch}
              biggerLayout={biggerLayout}
              handleSort={this.handleSort}
              changeLayout={this.changeLayout}
            />

            <div className='all-products '>
              {deletePopup && (
                <DeletePopUp
                  deleteRequestedProduct={deleteRequestedProduct}
                  handleDeletePopUP={this.handleDeletePopUP}
                  handleDelete={this.handleDelete}
                />
              )}

              <div className='row products-display'>
                {products.map((p) => (
                  <div
                    key={p._id}
                    className={biggerLayout ? smallLayout : bigLayout}
                  >
                    <ProductBlock
                      user={user}
                      id={p._id}
                      key={p._id}
                      label={p.label}
                      price={p.price}
                      imageUrl={p.imageUrl}
                      animationDelayz={(delay += 0.045)}
                      product={p}
                      doDelete={this.handleDeletePopUP}
                    />
                  </div>
                ))}
              </div>
            </div>

            <Pagination
              productsCount={totalCount}
              pageSize={pageSize}
              currentPage={currentPage}
              onPageChange={this.handlePageChange}
            />
          </>
        )}
      </React.Fragment>
    );
  }
}

export default Products;
